export const generateZipcodes = (min: number, max: number) => {
  const zips: string[] = [];
  for (let i: number = min; i <= max; i++) {
    zips.push(`${i}`);
  }
  return zips;
}
